import {
    IonButton,
    IonButtons,
    IonChip,
    IonContent,
    IonHeader,
    IonIcon,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonItem,
    IonLabel,
    IonList,
    IonModal,
    IonRadio,
    IonRadioGroup,
    IonSearchbar,
    IonTitle,
    IonToast,
    IonToolbar
} from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { personOutline, peopleOutline, closeCircle} from 'ionicons/icons';
import { modalController } from '@ionic/core';
import './UserGroupPicker.css';
import ServerService from '../services/Server';
//import { Environment } from "../data/Environment";

const server = new ServerService();

interface UserGroupPickerProps {
    state: any;
    onDismiss:any;
    addUG:any;
}

const UserGroupPicker: React.FC<UserGroupPickerProps> = ({state,onDismiss,addUG}) => {

  const [pickerState, setShowPicker] = useState({ showPicker:false, title:'', notIn:[], firstTime:false})
  const [type, setType] = useState("B")
  const [text, setText] = useState("")
  const [ugs, setUGs] = useState([])

  const [disableInfiniteScroll, setDisableInfiniteScroll] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [noMoreTask, setNoMoreTask] = useState(false);
  const [start, setStart] = useState(0);
  const [limit, setLimit] = useState(20);
 
  const loadData = async (event:CustomEvent<void>) => {
    await searchUserGroup();
    (event.target as HTMLIonInfiniteScrollElement).complete();
  }

  const searchUserGroup = () => {
    console.log("searchUserGroup()")
    
    const data = {s:text,t:type,notIn:JSON.stringify(pickerState.notIn),
      start:(start>=0 ? start : 0).toString(),
      limit:limit.toString(),
      m:"1"
    }
    fetch(server.getFullUrl("admin/main/userGroup/list", data),
        server.getRequest())
    .then(response => response.json()) // if the response is a JSON object
    .then(res => {
      if (res.success) {
        console.log("success")
        setUGs([...ugs, ...res.data]);

        //setItemCount(ugs.length + res.data.length)
        setTotalCount(res.total);

        setStart((start>=0 ? start : 0) + (res ? res.data.length : 0));

        setDisableInfiniteScroll(!res || res.data.length < limit);
        setNoMoreTask(start>0 && (!res || res.data.length < limit));
      } else {
        console.log("!success:"+res.message);
  
        if (res.message.startsWith("|BG_ERR|")) {
          //setErrMsg(res.message.substring("|BG_ERR|".length));
        } else {
          //setErrMsg(res.message);
        }
  
        //setError(true);
      }
    }).catch(
      error => {
        console.log(error) // Handle the error response object
      }
    )
  }

  const resetItems = () => {
    setDisableInfiniteScroll(false)
    setUGs([])
    setTotalCount(0)
    setStart(0)
  }

  useEffect(() => {
      //console.log("UserGroupPicker useEffect()")
      resetItems()
      // setStart(0)
      // setUGs([])
      // setTotalCount(0)
      if (state.showPicker !== pickerState.showPicker) {
        console.log("- change showPicker:"+state.showPicker+","+pickerState.showPicker)
        setShowPicker(state)
      }
  }, [state])

  useEffect(() => {
    console.log("Text:"+text+","+type+","+pickerState.notIn+","+pickerState.firstTime)
    if (pickerState.firstTime===undefined || pickerState.firstTime) {
      pickerState.firstTime = false
    } else {
      console.log("**start:"+start)
      searchUserGroup()
    }
  }, [text,type,pickerState])

  useEffect(() => {
    console.log("start:"+start)
    if (start < 0) {
      resetItems()
      searchUserGroup()
    }
  }, [start])

  return (
    <IonModal
        className="my-custom-class"
        isOpen={pickerState.showPicker}
        //swipeToClose={true}
        onDidDismiss={() => {
            onDismiss()
        }}
      >
        <IonHeader>
            <IonToolbar>
                <IonButtons slot="end">
                <IonButton onClick={async () => {await modalController.dismiss()}}>
                    <IonIcon slot="icon-only" icon={closeCircle}/>
                </IonButton>
                </IonButtons>
                <IonTitle>{pickerState.title}</IonTitle>
            </IonToolbar>
        
            <IonRadioGroup value={type} onIonChange={e => {
                  if (e.detail.value !== type) {
                    resetItems()
                    setType(e.detail.value)
                  }
              }}>
                <IonChip>
                <IonRadio value="B"/><IonLabel>&nbsp;All</IonLabel>
                </IonChip>
                <IonChip>
                <IonRadio value="G"/><IonLabel>&nbsp;Group</IonLabel>
                </IonChip>
                <IonChip>
                <IonRadio value="U"/><IonLabel>&nbsp;User</IonLabel>
                </IonChip>
                <IonChip color="primary">
                <IonLabel>{ugs ? ugs.length : 0}/{totalCount}</IonLabel>
                </IonChip>
            </IonRadioGroup>
        
            <IonSearchbar value={text} onIonChange={async e => {
                console.log("change:"+text+","+e.detail.value)
                if (e.detail.value !== text) {
                  resetItems()
                  setText(e.detail.value!)
                }
            }}/>
            
        </IonHeader>

        <IonContent>
        <IonList>
            {ugs?.map((ug,i) => {
                return (
                    <IonItem key={i} onClick={(e) => {
                      pickerState.notIn.push(ug)
                      resetItems()
                      setShowPicker(prevState => ({...prevState}))
                      addUG(state.list, ug);
                    }}>
                        <IonIcon icon={ug.type === "U" ? personOutline : peopleOutline}/>
                        <IonLabel>&nbsp;{ug.name}</IonLabel>
                    </IonItem>
                )
            })}
        </IonList>

        <IonInfiniteScroll threshold="10%" disabled={disableInfiniteScroll} onIonInfinite={loadData}>
          <IonInfiniteScrollContent
            loadingSpinner="circles"
            loadingText="Loading more tasks...">
          </IonInfiniteScrollContent>
        </IonInfiniteScroll>

        <IonToast
            isOpen={noMoreTask}
            message={'No More User/Group'}
            duration={2000}
            onDidDismiss={() => setNoMoreTask(false)}
            position="middle"
          />

        </IonContent>
    </IonModal>
  )
        
};

export default UserGroupPicker;
